import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button, Card, CardBody, CardTitle, Col, Container, Input, Label, Row, Spinner, Alert
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Autocomplete from "react-google-autocomplete";

const TalepDuzenle = () => {
  document.title = "Talebi Düzenle | Lojgo";
  const navigate = useNavigate();
  const { id } = useParams();

  const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const userId = authUser?.ID;
  const BASE_URL = "https://hiflowapi.stechomeyazilim.info";

  // --- STATE'LER ---
  const [loading, setLoading] = useState(true);
  const [publishing, setPublishing] = useState(false);
  const [alertConfig, setAlertConfig] = useState({ visible: false, message: "", type: "success" });

  const [locationId, setLocationId] = useState(null);
  const [existingUserPricings, setExistingUserPricings] = useState([]);

  const [startAddress, setStartAddress] = useState("");
  const [startLat, setStartLat] = useState(0);
  const [startLng, setStartLng] = useState(0);
  const [endAddress, setEndAddress] = useState("");
  const [endLat, setEndLat] = useState(0);
  const [endLng, setEndLng] = useState(0);
  const [km, setKm] = useState("");

  const [settings, setSettings] = useState(null);
  const [advertTypes, setAdvertTypes] = useState([]);
  const [advertTypeId, setAdvertTypeId] = useState(null);
  const [basePrice, setBasePrice] = useState("0");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [timeStart, setTimeStart] = useState("");
  const [timeEnd, setTimeEnd] = useState("");

  const [cars, setCars] = useState([]);
  const [selectedCarId, setSelectedCarId] = useState(""); 
  const [carForm, setCarForm] = useState({
    carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: ""
  });

  const [pricingOptions, setPricingOptions] = useState([]);
  const [selectedExtras, setSelectedExtras] = useState({});
  const [advertNote, setAdvertNote] = useState("");
  const [quickOfferPriceOverride, setQuickOfferPriceOverride] = useState("");
  const [originalPrice, setOriginalPrice] = useState(0);

  const showAlert = (message, type = "success") => {
    setAlertConfig({ visible: true, message, type });
    setTimeout(() => setAlertConfig({ visible: false, message: "", type: "success" }), 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  };

  // --- GOOGLE DIRECTIONS KM HESAPLAMA ---
  async function getRouteDistanceKm(originLat, originLng, destLat, destLng, apiKey) {
    try {
      const url = `https://maps.googleapis.com/maps/api/directions/json?origin=${originLat},${originLng}&destination=${destLat},${destLng}&mode=driving&key=${apiKey}`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.status === "OK" && data.routes.length > 0) {
        return data.routes[0].legs[0].distance.value / 1000;
      }
      return null;
    } catch (error) {
      console.error("Mesafe çekme hatası:", error);
      return null;
    }
  }

  // KM Tetikleyici
  useEffect(() => {
    const calculateRoute = async () => {
      if (startLat && startLng && endLat && endLng) {
        const dist = await getRouteDistanceKm(startLat, startLng, endLat, endLng, GOOGLE_API_KEY);
        if (dist) setKm(dist.toFixed(2));
      }
    };
    calculateRoute();
  }, [startLat, startLng, endLat, endLng]);

  // Veri Yükleme
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const [typeRes, carRes, pricingRes, settingsRes] = await Promise.all([
            fetch(`${BASE_URL}/Advert_Type`),
            fetch(`${BASE_URL}/Users_Car?$filter=Users_ID eq ${userId} and IsActive eq true&$orderby=ID desc`),
            fetch(`${BASE_URL}/Advert_Pricing`),
            fetch(`${BASE_URL}/Settings?$top=1`)
        ]);

        setAdvertTypes((await typeRes.json()).value || []);
        const userCars = (await carRes.json()).value || [];
        setCars(userCars);
        setPricingOptions((await pricingRes.json()).value || []);
        setSettings((await settingsRes.json()).value?.[0]);

        const advertRes = await fetch(`${BASE_URL}/Advert?$filter=ID eq ${id}&$expand=Advert_Location,Users_Car`);
        const advert = (await advertRes.json()).value?.[0];

        if (advert) {
            setAdvertTypeId(advert.Advert_Type_ID);
            setAdvertNote(advert.Advert_Note || "");
            if (advert.Quick_Offer_Price != null) {
                setQuickOfferPriceOverride(advert.Quick_Offer_Price.toString());
            }
            if (advert.Advert_DateTime) {
                setStartDate(new Date(advert.Advert_DateTime));
                setTimeStart(new Date(advert.Advert_DateTime).toTimeString().slice(0,5));
            }
            if (advert.Advert_DateTime2) {
                setEndDate(new Date(advert.Advert_DateTime2));
                setTimeEnd(new Date(advert.Advert_DateTime2).toTimeString().slice(0,5));
            }
            if (advert.Car_ID) {
                setSelectedCarId(advert.Car_ID.toString());
                const c = advert.Users_Car;
                if (c) setCarForm({
                    carPlate: c.Users_Car_Plate || "", carBrand: c.Users_Car_Brand || "",
                    carModel: c.Users_Car_Model || "", carBodyType: c.Car_Body_Type || "",
                    engineType: c.Engine_Type || "", chassisInformation: c.ChassisInformation || ""
                });
            }
            const loc = advert.Advert_Location?.[0];
            if (loc) {
                setLocationId(loc.ID);
                setStartAddress(loc.Advert_Location_StartAddress || "");
                setStartLat(loc.Advert_Location_Lat_Start); setStartLng(loc.Advert_Location_Long_Start);
                setEndAddress(loc.Advert_Location_FinishAddress || "");
                setEndLat(loc.Advert_Location_Lat_Finish); setEndLng(loc.Advert_Location_Long_Finish);
                setKm(loc.Km?.toString() || "");
            }

            const uapRes = await fetch(`${BASE_URL}/Users_Advert_Pricing?$filter=Advert_ID eq ${id}`);
            const existingExtrasList = (await uapRes.json()).value || [];
            setExistingUserPricings(existingExtrasList);
            const extrasMap = {};
            existingExtrasList.forEach(item => extrasMap[item.Advert_Pricing_ID] = true);
            setSelectedExtras(extrasMap);
        }
      } catch (e) { showAlert("Veriler yüklenemedi.", "danger"); }
      finally { setLoading(false); }
    };
    loadData();
  }, [userId, id]);

  useEffect(() => {
    if (!settings || !advertTypeId) return;
    const selectedType = advertTypes.find(t => t.ID === advertTypeId);
    const isDriver = (selectedType?.Advert_Type_Title || "").toLowerCase().includes("sürücü");
    setBasePrice(isDriver ? settings.Km_Price_Car : settings.Km_Price_);
  }, [settings, advertTypeId, advertTypes]);

  const handleCarSelect = (e) => {
    const val = e.target.value;
    setSelectedCarId(val);
    if (val !== "new" && val !== "") {
      const c = cars.find(x => x.ID.toString() === val);
      if (c) setCarForm({
        carPlate: c.Users_Car_Plate || "", carBrand: c.Users_Car_Brand || "",
        carModel: c.Users_Car_Model || "", carBodyType: c.Car_Body_Type || "",
        engineType: c.Engine_Type || "", chassisInformation: c.ChassisInformation || ""
      });
    } else {
      setCarForm({ carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: "" });
    }
  };

  const handleDeleteCar = async () => {
    if (!window.confirm("Bu aracı silmek istediğinize emin misiniz?")) return;
    try {
        await fetch(`${BASE_URL}/Users_Car(${selectedCarId})`, { 
            method: "PATCH", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ IsActive: false }) 
        });
        setCars(cars.filter(c => c.ID.toString() !== selectedCarId));
        setSelectedCarId("new");
        setCarForm({ carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: "" });
        showAlert("Araç silindi.");
    } catch (e) { showAlert("Silme hatası.", "danger"); }
  };

  const totalPrice = useMemo(() => {
    const subTotal = (parseFloat(km) || 0) * (parseFloat(basePrice) || 0);
    const extraTotal = pricingOptions.filter(i => !i.Is_Cancel_Policy).reduce((sum, item) =>
        sum + (selectedExtras[item.ID] ? parseFloat(item.Price) : 0), 0);
    return subTotal + extraTotal;
  }, [km, basePrice, selectedExtras, pricingOptions]);

  const autoQuickOfferPrice = useMemo(() => {
    const pct = parseFloat(settings?.Quick_Offer_Percentage) || 0;
    return totalPrice * (pct / 100);
  }, [totalPrice, settings]);

  const effectiveQuickOfferPrice = useMemo(() => {
    const override = parseFloat(quickOfferPriceOverride);
    return !isNaN(override) && quickOfferPriceOverride !== "" ? override : autoQuickOfferPrice;
  }, [quickOfferPriceOverride, autoQuickOfferPrice]);

  const handleUpdate = async () => {
    if (!startAddress || !endAddress || !km || !carForm.carPlate || !startDate || !endDate || !timeStart || !timeEnd) {
      showAlert("Lütfen tüm alanları doldurun.", "danger");
      return;
    }

    setPublishing(true);
    try {
      const startDT = new Date(startDate); const [sh, sm] = timeStart.split(":"); startDT.setHours(sh, sm, 0);
      const endDT = new Date(endDate); const [eh, em] = timeEnd.split(":"); endDT.setHours(eh, em, 0);

      if (endDT <= startDT) {
        showAlert("Bitiş zamanı başlangıçtan sonra olmalıdır.", "danger");
        setPublishing(false); return;
      }

      // Araç İşlemi (Upsert)
      let finalCarId = selectedCarId === "new" || selectedCarId === "" ? null : parseInt(selectedCarId);
      if (selectedCarId === "new" || selectedCarId === "") {
        const carRes = await fetch(`${BASE_URL}/Users_Car`, {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...carForm, Users_ID: userId, IsActive: true })
        });
        const carData = await carRes.json();
        finalCarId = carData?.ID || carData?.value?.[0]?.ID;
      } else {
        await fetch(`${BASE_URL}/Users_Car(${selectedCarId})`, {
            method: "PATCH", headers: { "Content-Type": "application/json" },
            body: JSON.stringify(carForm)
        });
      }

      const diffMs = endDT.getTime() - startDT.getTime();
      const estimatedDuration = `${String(Math.floor(diffMs/3600000)).padStart(2,"0")}:${String((diffMs%3600000)/60000).padStart(2,"0")}`;

      // 1. İlanı Güncelle
      await fetch(`${BASE_URL}/Advert(${id})`, {
        method: "PATCH", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Advert_DateTime: startDT.toISOString(), Advert_DateTime2: endDT.toISOString(),
          Price: originalPrice,
          Car_ID: finalCarId, Estimated_Duration: estimatedDuration
        })
      });

      showAlert("İlan başarıyla güncellendi!", "success");
      setTimeout(() => navigate("/job-apply"), 1500);
    } catch (error) { showAlert("Hata oluştu.", "danger"); setPublishing(false); }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Görevler" breadcrumbItem="Talebi Düzenle" />
          <Alert isOpen={alertConfig.visible} color={alertConfig.type} className="border-0 shadow-sm">
            {alertConfig.message}
          </Alert>

          {loading ? (
             <div className="text-center py-5"><Spinner color="primary" /></div>
          ) : (
            <Row>
              <Col lg="8">
                {/* GÖREV TİPİ */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold">Görev Tipi</CardTitle>
                    <div className="d-flex flex-wrap gap-2">
                      {advertTypes.map((type) => (
                        <Button key={type.ID} color={advertTypeId === type.ID ? "primary" : "light"} disabled>
                          {type.Advert_Type_Title}
                        </Button>
                      ))}
                    </div>
                  </CardBody>
                </Card>

                {/* ROTA */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold">Rota Planlaması</CardTitle>
                    <Row>
                      <Col md="12" className="mb-3">
                        <Label>Başlangıç Adresi</Label>
                        <Autocomplete apiKey={GOOGLE_API_KEY} className="form-control" value={startAddress} disabled
                          options={{ componentRestrictions: { country: "tr" } }} />
                      </Col>
                      <Col md="12" className="mb-3">
                        <Label>Varış Adresi</Label>
                        <Autocomplete apiKey={GOOGLE_API_KEY} className="form-control" value={endAddress} disabled
                          options={{ componentRestrictions: { country: "tr" } }} />
                      </Col>
                      <Col md="6">
                        <Label>Mesafe (KM)</Label>
                        <Input type="number" value={km} disabled className="bg-light fw-bold text-primary" />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* ZAMANLAMA */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold">Zaman Planlaması</CardTitle>
                    <Row>
                      <Col md="6" className="mb-3">
                        <Label>Başlangıç Tarihi</Label>
                        <FlatPickr className="form-control" value={startDate} options={{ dateFormat: "Y-m-d", minDate: "today" }} onChange={(date) => setStartDate(date[0])} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Başlangıç Saati</Label>
                        <Input type="time" value={timeStart} onChange={e => setTimeStart(e.target.value)} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Bitiş Tarihi</Label>
                        <FlatPickr className="form-control" value={endDate} options={{ dateFormat: "Y-m-d", minDate: startDate || "today" }} onChange={(date) => setEndDate(date[0])} />
                      </Col>
                      <Col md="6">
                        <Label>Bitiş Saati</Label>
                        <Input type="time" value={timeEnd} onChange={e => {
                            if (startDate && endDate && startDate.toDateString() === endDate.toDateString() && e.target.value <= timeStart) {
                                showAlert("Bitiş saati başlangıçtan sonra olmalıdır.", "danger"); return;
                            }
                            setTimeEnd(e.target.value);
                        }} />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* ARAÇ */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <div className="d-flex justify-content-between mb-4">
                        <CardTitle className="mb-0 fw-bold">Araç Bilgileri</CardTitle>
                        <div className="d-flex gap-2">
                            <Input type="select" className="w-auto" value={selectedCarId} onChange={handleCarSelect}>
                                <option value="new">+ Yeni Araç</option>
                                {cars.map(c => <option key={c.ID} value={c.ID}>{c.Users_Car_Plate}</option>)}
                            </Input>
                            {selectedCarId && selectedCarId !== "new" && <Button color="danger" outline size="sm" onClick={handleDeleteCar}>Sil</Button>}
                        </div>
                    </div>
                    <Row>
                      <Col md="12" className="mb-3"><Label>Plaka</Label><Input type="text" value={carForm.carPlate} onChange={e => setCarForm({...carForm, carPlate: e.target.value})} /></Col>
                      <Col md="6" className="mb-3"><Label>Marka</Label><Input type="text" value={carForm.carBrand} onChange={e => setCarForm({...carForm, carBrand: e.target.value})} /></Col>
                      <Col md="6" className="mb-3"><Label>Model</Label><Input type="text" value={carForm.carModel} onChange={e => setCarForm({...carForm, carModel: e.target.value})} /></Col>
                      <Col md="4"><Label>Kasa</Label><Input type="text" value={carForm.carBodyType} onChange={e => setCarForm({...carForm, carBodyType: e.target.value})} /></Col>
                      <Col md="4"><Label>Motor</Label><Input type="text" value={carForm.engineType} onChange={e => setCarForm({...carForm, engineType: e.target.value})} /></Col>
                      <Col md="4"><Label>Şase</Label><Input type="text" value={carForm.chassisInformation} onChange={e => setCarForm({...carForm, chassisInformation: e.target.value})} /></Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* NOT */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold">Müşteri Notu</CardTitle>
                    <Input type="textarea" rows="3" value={advertNote} disabled />
                  </CardBody>
                </Card>
              </Col>

              {/* ÖZET */}
              <Col lg="4">
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold">Ek Hizmetler</CardTitle>
                    {pricingOptions.filter(i => !i.Is_Cancel_Policy).map(item => (
                        <div key={item.ID} className={`p-3 mb-3 border rounded-3 d-flex justify-content-between ${selectedExtras[item.ID] ? 'bg-soft-primary border-primary' : ''}`}>
                            <div>
                                <h6 className="fw-bold mb-1">{item.Advert_Pricing_Title}</h6>
                                <span className="text-primary">+{item.Price} TL</span>
                            </div>
                            <Input type="checkbox" checked={selectedExtras[item.ID] || false} disabled />
                        </div>
                    ))}
                  </CardBody>
                </Card>

                <div style={{ position: "sticky", top: "85px" }}>
                    <Card className="shadow-sm border border-warning rounded-4">
                    <CardBody className="p-4">
                        <h5 className="fw-bold text-center mb-4 text-warning">Düzenleme Özeti</h5>
                        <div className="d-flex justify-content-between mb-3 border-bottom pb-3">
                            <span className="fw-bold">Toplam Tutar</span>
                            <h2 className="text-warning fw-bold mb-0">{totalPrice.toFixed(2)} TL</h2>
                        </div>
                        <div className="mb-3" />
                        <Button color="warning" size="lg" className="w-100 fw-bold" onClick={handleUpdate} disabled={publishing}>
                            {publishing ? <Spinner size="sm" /> : "Değişiklikleri Kaydet"}
                        </Button>
                    </CardBody>
                    </Card>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TalepDuzenle;